import Route from '@core/components/Route';

import { Faq } from '../../types/faq';

export const MARTIAL_ARTS_FAQ: Faq[] = [
  {
    a: 'Manche sagen, dass die wahre Meisterschaft erst mit ca. 50 Jahren angestrebt werden kann. Du bist absolut willkommen!',
    q: 'Ich bin über 40 Jahre alt. Kann ich noch einsteigen?',
  },
  {
    a: 'Unser System basiert auf dem militärischen Nahkampf. Grundsätzlich kann man damit einen Selbstverteidigungs-Spezialisten in kurzer Zeit ausbilden. Allerdings setzen wir die Unterrichts-Schwerpunkte überwiegend auf Trainings- und Meister-Arbeit. Nutze am Besten das Probetraining, um mit unseren Ausbildern über Deine Situation und Deine Wünsche zu sprechen.',
    q: 'Ich interessiere mich für Selbstverteidigung. Bin ich hier richtig?',
  },
  {
    a: (
      <>
        Wo ein Wille ist, ist auch ein Weg! Nutze bitte gern unsere{' '}
        <Route href='https://shop.systema-berlin.de'>Lehrvideos</Route> in unserem Shop. Darüber
        hinaus bieten wir auch Seminare und Privatunterricht an. Nimm gern Kontakt zu uns auf, wenn
        Du weitere Fragen haben solltest.
      </>
    ),
    q: 'Ich wohne zu weit weg. Gibt es eine Möglichkeit für mich, von Euch zu lernen?',
  },
  {
    a: 'Überhaupt nicht! Alle Übungen werden immer auf die Gruppe abgestimmt, es gibt keinen Zwang und alle entscheiden selbst, wie viel sie leisten könnnen. Mach Dir keine Sorgen - komm einfach zum Probetraining und genieße.',
    q: 'Muss ich sportlich genug sein, um bei Euch zu trainieren?',
  },
  {
    a: 'Idealerweise besprichst Du das beim Probetraining mit einem Ausbilder. Grundsätzlich haben wir die Erfahrung gemacht, dass sich viele Probleme durch unser Training verbessern.',
    q: 'Ich habe körperliche Einschränkungen. Kann ich trotzdem trainieren?',
  },
  {
    a: 'Wir sind keine Psychologen. Unserem System liegt aber eine einzigartige Philosophie zu Grunde und wir bieten mit der Vektor-Psychologie und der Kriegerlehre entsprechende Ausbildungen an. Bitte nimm Kontakt zu uns auf und lass uns darüber sprechen.',
    q: 'Ich habe psychische Probleme. Könnt Ihr mir helfen?',
  },
  {
    a: 'Bitte registriere Dich in unserer Telegram Gruppe. Den Link findest Du ganz unten auf unserer Website.',
    q: 'Wo bekomme ich aktuelle Informationen zu Training und Seminaren?',
  },
  {
    a: 'Das VIP-Programm kann die richtige Wahl für Dich sein. Bitte sprich Falko darauf an.',
    q: 'Ich möchte extra schnell lernen. Bietet Ihr etwas entsprechendes an?',
  },
  {
    a: 'Beim Kampfsport geht es um viele sportliche Aspekte, wie etwa sportliche Fitness und Wettkämpfe. In der Kampfkunst, so wie wir sie verstehen, geht es eher um das Erreichen von inneren Werten: Ein ausbalancierter psychischer Zustand, Ruhe, Frieden, Freiheit, Glück. Wir fokussieren uns hauptsächlich auf die Meisterschaft und etwas auf Selbstverteidigung.',
    q: 'Ihr bezeichnet Euer System als Kampfkunst. Was ist der Unterschied zwischen Kampfsport und Kampfkunst?',
  },
  {
    a: 'An unserem Training kann jeder ab 18 Jahren teilnehmen.',
    q: 'Können meine Kinder bei Euch trainieren?',
  },
];
